import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { ownerGuard } from './core/guards/owner.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/home/home').then((m) => m.HomeComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login').then((m) => m.LoginComponent),
  },
  {
    path: 'auth/complete',
    loadComponent: () =>
      import('./features/auth/auth-complete/auth-complete').then((m) => m.AuthCompleteComponent),
  },
  {
    path: 'book',
    loadComponent: () => import('./features/booking/book/book').then((m) => m.BookComponent),
  },
  {
    path: 'my-bookings',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/booking/my-bookings/my-bookings').then((m) => m.MyBookingsComponent),
  },
  {
    path: 'booking-confirmed/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/booking/booking-confirmed/booking-confirmed').then(
        (m) => m.BookingConfirmedComponent,
      ),
  },
  {
    path: 'owner',
    canActivate: [authGuard, ownerGuard],
    loadComponent: () =>
      import('./features/owner/dashboard/owner-dashboard').then((m) => m.OwnerDashboardComponent),
  },
  { path: '**', redirectTo: '' },
];
